import { TeachingSkill, TEACHING_SKILLS_BY_ID } from 'app/constants/TeachingSkills';
import createErrorType from 'app/utils/createErrorType';
import { fold, left } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/pipeable';
import * as t from 'io-ts';
import { PathReporter } from 'io-ts/lib/PathReporter';

export { TeachingSkill };

export class InvalidTeacherSkill extends createErrorType('InvalidTeacherSkill') {}

export const TeachingSkillMarshaller = {
  deserialize: (id: unknown): TeachingSkill => {
    return pipe(
      t.string.decode(id),
      fold(
        (l) => {
          throw new InvalidTeacherSkill(PathReporter.report(left(l)).join('\n'));
        },
        (r) => {
          const teachingSkill = TEACHING_SKILLS_BY_ID.get(r);

          if (!teachingSkill) {
            throw new InvalidTeacherSkill(`The value '${r}' is not a valid TeachingSkill.`);
          }

          return teachingSkill;
        },
      ),
    );
  },
  serialize: (teachingSkill: TeachingSkill) => teachingSkill.id,
};
